<app-nav-menu></app-nav-menu>
<p-toast></p-toast>
<div class="main_Div">
  <div class="listHeadingSection">
    <div class="beneficiaryHeading" id="beneficiaryHeadings">
      Group Revenue List
    </div>
    <div class="addNewBeneficiaryDiv desktop-only">
      <button type="button" (click)="AddNewRevenueGroup()" class="addNewBeneficiaryButton">
        <i class="fas fa-plus-circle"></i><span>Add New</span>
      </button>
    </div>
  </div>
  <div class="tableContainer">
    <dx-data-grid class="ticketTabel" #listGrid [dataSource]="GroupRevenue" [showBorders]="true"
      [showRowLines]="true" [columnAutoWidth]="true">
      <dxo-scrolling mode="standard" [useNative]="true"></dxo-scrolling>
      <dxo-paging [pageSize]="10"></dxo-paging>
      <dxo-search-panel [visible]="true"></dxo-search-panel>
      <dxo-pager [showPageSizeSelector]="true" [allowedPageSizes]="[10, 25, 50, 100]"></dxo-pager>

      <dxo-toolbar>
        <dxi-item location="before" cssClass="mobile-only-add-button">
          <div *dxTemplate>
            <button type="button" (click)="AddNewRevenueGroup()" class="addNewBeneficiaryButton">
              <i class="fas fa-plus-circle"></i><span>Add New</span>
            </button>
          </div>
        </dxi-item>
        <dxi-item name="searchPanel" location="after"></dxi-item>
      </dxo-toolbar>

      <dxi-column [visible]="false" dataField="groupId" caption="Group Id" alignment="start"></dxi-column>
      <dxi-column dataField="groupName" caption="Group Name" alignment="start" [minWidth]="120"></dxi-column>
      <!-- <dxi-column dataField="agencyId" caption="AgencyId" alignment="start"></dxi-column> -->
      <dxi-column dataField="expiryDate" caption="Expiry Date" alignment="start" [minWidth]="110"></dxi-column>
      <dxi-column dataField="agencyCodeList" caption="Agency Code List" alignment="start" [minWidth]="160"></dxi-column>
      <dxi-column caption="Action" [allowSorting]="false" alignment="center" [minWidth]="115" [width]="115"
      cellTemplate="actionCellTemplate"></dxi-column>


      <div *dxTemplate="let response of 'actionCellTemplate'">
        <div class="card_buttons">
          <a class="card_button-edit" (click)="EditGroupRevenue(response.data.groupId)" title="Edit">
            <i class="uil uil-edit card_button-icon"></i>
          </a>
          <a class="cardBlock" (click)="DeleteGroup(response.data.groupId)" title="Delete">
            <img class="imageBlock" src="assets/img/remove.png" alt="Delete" />
          </a>
        </div>
      </div>
    </dx-data-grid>
  </div>
</div>

<p-dialog class="pDialog" [(visible)]="primeShowModalBeneficiaryModel" [style]="{width: '70%'}" [modal]="true" [draggable]="false" >
  <div class="Main_page">
    <div
      style="padding: 20px; background-color: white; box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px; width: 100%; border-radius: 5px; ">
      <div class="row m-0 p-0">
        <div class="col-md-12 p-0">
          <div class="SearchPannel ">
            <div class="row m-0">
              <div class="heading_page">
                <span>Group Revenue Report</span>
              </div>
            </div>
          </div>

        </div>
      </div>
      <div class="row mt-1">
        <div class="col-md-4">
          <label>Name</label>
          <!-- <input type="text" autocomplete="off" name="name" id="Groupname" class="main_text-box" [ngModelOptions]="{standalone:true}" [(ngModel)]="RevenueReportData.groupName"/> -->
          <input type="text" [disabled]="ModifyButton" autocomplete="off" name="name" id="Groupname" (change)="grouprevenuenamecheck(RevenueReportData.groupName)" class="main_text-box" [(ngModel)]="RevenueReportData.groupName"/>
          <span class="messgereq" id="messagename"></span>
        </div>
        <div class="col-md-4"></div>
        <div class="col-md-4 pl-0">
          <label>Expiry Date</label>
          <input type="date" min="{{minDate}}" name="expiryDate" id="expiryDate" class="main_text-box" [(ngModel)]="RevenueReportData.expiryDate" />
          <span class="messgereq" id="messageexpiryDate"></span>
        </div>
      </div>
      <hr />
      <div class="row mt-2 mb-1">
        <div class="scrollable-div col-md-5">
          <div style="border: 1px solid #ccc; border-radius: 0.25rem;">
            <div class="row">
              <div class="ListHeading">
                <p style="padding: 3%; margin: 0">Agency & Branch List</p>
              </div>
            </div>
            <hr style="margin: 0;">
            @for (agency of agencyList; track agency; let i = $index) {
              <div class="p-1">
                <div class="p-1 d-flex justify-content-between">
                  <label class="agency-name-font" for="checkbox_id{{i}}">{{agency}}</label>
                  <input type="checkbox" name="checkbox" class="AgencyCheckBoxes" id="checkbox_id{{i}}" [(ngModel)]="checkboxState[i]"
                    value="{{i}}" style="float: right;" >
                  </div>
                </div>
              }
            </div>
          </div>
          <div class="col-md-2 p-0 d-flex flex-column justify-content-center">
            <div>
              <div style="display: block; text-align: center;">
                <button class="button-iMAGE" (click)="shiftAgency()"><i class="fas fa-angle-right" aria-hidden="true" style="font-size:x-large"></i></button>
              </div>
              <br>
                <div style="display: block; text-align: center;">
                  <button class="button-iMAGE" (click)="shiftAllAgencies()"><i class="fas fa-angle-double-right" aria-hidden="true" style="font-size:x-large"></i></button>
                </div>
              </div>
            </div>
            <div style="border: 1px solid #ccc; border-radius: 0.25rem;" class="scrollable-div col-md-5">
              <div>
                <div class="row">
                  <div class="ListHeading">
                    <p style="padding: 3%; margin: 0">Grouped Agency & Branch List</p>
                  </div>
                </div>
                <hr style="margin: 0;">
                @for (agency of agencynewList; track agency; let i = $index) {
                  <div>
                    <div class="p-1">
                      <i class="fas fa-times" (click)="ClearSelection(i)" style="margin-right: 10px; color: red; cursor: pointer; align-self: center;" aria-hidden="true"></i>
                      <label for="checkbox_id" id="agencyListChk">{{agency}}</label>
                    </div>
                  </div>
                }

              </div>
              <span class="messgereq" id="AgencyCheck"></span>
            </div>

          </div>
          <div class="row">
            @if (SaveButton) {
              <div class="col-md-12 mt-1">
                <button style="float: right;" class="button-iMAGE mr-2" id="btnSave"
                (click)="SaveRevenueGroup()">Save</button>
              </div>
            }
            @if (ModifyButton) {
              <div class="col-md-12 mt-1">
                <button style="float: right;" class="button-iMAGE mr-2" id="btnSave"
                (click)="ModifyRevenueGroup()">Modify</button>
              </div>
            }
          </div>
        </div>
      </div>
    </p-dialog>
